import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL
})
export default instance



// http://3.27.235.199

// Get request
// admin/getproducts
// admin/category


// post request

// admin/login
// admin/addproduct
// admin/addcategory